import React, { useState, useEffect } from "react";
import { Formik, Field, Form, FieldArray, ErrorMessage } from "formik";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { values } from "lodash";
import DepartmentForm from "../Forms/DepartmentForm";
import BranchForm from "../Forms/BranchForm";
import DesignationForm from "../Forms/DesignationForm";
import {
  CustomSelect,
  getData,
  postData,
} from "../Commonfunction/CommonFunction";
import CommonModal from "../common/CommonModal";
import { useUser } from "../Commonfunction/UserContext";
import PermissionMessage from "../common/PermissionMessage";
import CenteredLoading from "../common/CenteredLoading";
import { checkPermission } from "../Commonfunction/NewPermission";
import "../../assets/style/EmployeForm.css";
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import { CiSquarePlus } from "react-icons/ci";
import { GrAction, GrDocumentImage } from "react-icons/gr";
import { IoArrowBack, IoDocumentAttach } from "react-icons/io5";
import { FaCloudUploadAlt } from "react-icons/fa";
import { MdAddToPhotos, MdOutlinePreview } from "react-icons/md";
import { HiMiniDocumentMagnifyingGlass } from "react-icons/hi2";
import { RiDeleteBinFill } from "react-icons/ri";

export default function EmployeesForm() {
  const location = useLocation();

  const [expanded, setExpanded] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [branchModal, setBranchModal] = useState();
  const [departmentModal, setDepartmentModal] = useState();
  const [designationModal, setDesignationModal] = useState();
  const [branchData, setBranchData] = useState();
  const [singleData, setSingleData] = useState();
  const [departmentData, setDepartmentData] = useState();
  const [designationData, setDesignationData] = useState();
  const { setUserAccess } = useUser();
  const [permissionMassage, setPermissionMassage] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleCut = (event) => {
    event.preventDefault();
  };

  const handleCopy = (event) => {
    event.preventDefault();
  };

  const handlePaste = (event) => {
    event.preventDefault();
  };

  const deparmentList = async () => {
    try {
      const result = await getData(`/api/all-departments`);
      if (result.success) {
        const data = result.data?.map((item) => ({
          label: item.department_name,
          value: item.id,
        }));

        setDepartmentData(data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const designationList = async () => {
    try {
      const result = await getData(`/api/all-designations`);
      if (result.success) {
        const data = result.data?.map((item) => ({
          label: item.designation_name,
          value: item.id,
        }));

        setDesignationData(data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    setExpanded("panel1");
    deparmentList();
    designationList();
  }, []);

  const singleCustomerData = async () => {
    try {
      const result = await getData(`/api/get-employee/${id}`);
      if (result.success) {
        setSingleData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const request_url = id
        ? `/api/update-employee/${id}`
        : "/api/create-employee";
      const postDataResult = await postData(request_url, values);
      if (postDataResult.success) {
        toast.success(postDataResult.message);
        navigate("/employees");
      } else {
        // console.log("test==>121", postDataResult);
        toast.error(postDataResult.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      setLoading(false);
    }
  };

  const employeeType = [
    { label: "Email Operator", value: "email_operator" },
    { label: "Data Entry Operator", value: "data_entry_operator" },
    { label: "Reviewer", value: "reviewer" },
    { label: "Team Lead", value: "team_lead" },
  ];

  const genders = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
  ];

  const countryList = [
    { label: "India", value: "in" },
    { label: "USA", value: "us" },
  ];

  const validationSchema = Yup.object().shape({
    employee_type: Yup.string().required("Employee Type is required"),
    first_name: Yup.string().required("First Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    email: Yup.string().email("Invalid email").required("Email is Required"),
    gender: Yup.string().required("Please select gender"),
    street_1: Yup.string().required("Street 1 is required"),
    country: Yup.string().required("Cuntry is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    pincode: Yup.string().required("Pincode is required"),
    // mobile_no: Yup.string().required("Mobile number is required"),
    mobile_no: Yup.string().test(
      "length",
      "Mobile number must be 10 digits long.",
      (value) => {
        if (!value) return false;
        // Remove any non-digit characters (e.g., spaces, dashes)
        const digits = value.replace(/\D/g, "");
        return digits.length >= 11;
      }
    ),

    bank_details: Yup.array().of(
      Yup.object().shape(
        values.country == "us"
          ? {
              is_primary: Yup.string().required(
                "Please select primary bank account"
              ),
              account_holder_name: Yup.string().required(
                "Account holder name is required"
              ),
              bank_name: Yup.string().required("Bank name is required"),
              bank_branch: Yup.string().required("Bank branch is required"),
              account_type: Yup.string().required(
                "Bank account type is required"
              ),
              routing_number: Yup.string().required(
                "Routing number is required"
              ),
              bank_account_no: Yup.string().required(
                "Bank account number is required"
              ),
              bank_account_no_cnf: Yup.string()
                .required("Confirm account number is required")
                .oneOf(
                  [Yup.ref("bank_account_no"), null],
                  "Account numbers must match"
                ),
            }
          : {
              is_primary: Yup.string().required(
                "Please select primary bank account"
              ),
              bank_name: Yup.string().required("Bank name is required"),
              account_holder_name: Yup.string().required(
                "Account holder name is required"
              ),
              bank_branch: Yup.string().required("Bank branch is required"),
              ifsc_code: Yup.string().required("IFSC code is required"),

              bank_account_no: Yup.string().required(
                "Bank account number is required"
              ),
              bank_account_no_cnf: Yup.string()
                .required("Confirm account number is required")
                .oneOf(
                  [Yup.ref("bank_account_no"), null],
                  "Account numbers must match"
                ),
            }
      )
    ),

    branch_id: Yup.string().required("Please select branch"),
    department_id: Yup.string().required("Please select department"),
    designation_id: Yup.string().required("Please select designation"),

    document_info: Yup.array().of(
      Yup.object().shape({
        document_name: Yup.string().required("Document info is required"),
        employee_documents: Yup.string().required(
          "Employee documents is required"
        ),
      })
    ),
  });

  const fetchData = async () => {
    try {
      const result = await getData("/api/user-access");
      if (result.success) {
        if (location?.pathname === "/add-employee") {
          if (!checkPermission("Employees", "add", result.permission)) {
            setPermissionMassage(true);
            setTimeout(() => {
              navigate("/");
            }, 2000);
          }
        }
        if (id) {
          if (!checkPermission("Employees", "edit", result.permission)) {
            setPermissionMassage(true);
            setTimeout(() => {
              navigate("/");
            }, 2000);
          }
        }
        setUserAccess(result);
      }
    } catch (error) {
      console.log("Error:123213", error);
    }
  };

  const branchList = async () => {
    try {
      const result = await getData("/api/all-branches");
      if (result.success) {
        setBranchData(result.data);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  useEffect(() => {
    fetchData();
    branchList();
    id && singleCustomerData();
  }, []);

  const handleClose = () => {
    setDepartmentModal(false),
      setBranchModal(false),
      setDesignationModal(false),
      branchList();
    deparmentList(), designationList();
  };
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const [filePreviews, setFilePreviews] = useState([]);
  const handleFileChange = async (event, index, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue(`document_info.${index}.file`, file);
    if (file) {
      const base64 = await fileToBase64(file);
      setFieldValue(`document_info.${index}.employee_documents`, base64);

      // Update previews
      setFilePreviews((prevPreviews) => {
        const newPreviews = [...prevPreviews];
        newPreviews[index] = { name: file.name, base64 };
        return newPreviews;
      });
    }
  };

  // console.log("testing", id ? singleData?.first_name : "");

  return (
    <div className="bg-white">
      <Formik
        initialValues={{
          // part:-1
          employee_type: id ? singleData?.employee_type : "",
          first_name: id ? singleData?.first_name : "",
          last_name: id ? singleData?.last_name : "",
          email: id ? singleData?.email : "",
          mobile_no: id ? singleData?.mobile_no : "",
          gender: id ? singleData?.gender : "",
          country: id ? singleData?.country : "",
          city: id ? singleData?.city : "",
          state: id ? singleData?.state : "",
          pincode: id ? singleData?.pincode : "",
          street_1: id ? singleData?.street_1 : "",
          street_2: id ? singleData?.street_2 : "",

          // part:-2
          bank_details: id
            ? singleData?.bank_details
            : [
                {
                  account_holder_name: "",
                  bank_name: "",
                  bank_branch: "",
                  account_type: "",
                  bank_account_no: "",
                  bank_account_no_cnf: "",
                  routing_number: "",
                  is_primary: false,
                  ifsc_code: "",
                },
              ],

          // part:-3
          branch_id: id ? singleData?.branch_id : "",
          department_id: id ? singleData?.department_id : "",
          designation_id: id ? singleData?.designation_id : "",

          // part:-4
          document_info: id
            ? singleData?.documents
            : [
                {
                  document_name: "",
                  employee_documents: "",
                },
                {
                  document_name: "",
                  employee_documents: "",
                },
                {
                  document_name: "",
                  employee_documents: "",
                },
                {
                  document_name: "",
                  employee_documents: "",
                },
                {
                  document_name: "",
                  employee_documents: "",
                },
              ],
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form className="modern-form-container">
            <div className="heading-wrapper">
              <button
                 type="button"
                className="back-button"
                onClick={() => navigate("/employees")}
                title="Back to Employees"
              >
                <IoArrowBack />
              </button>
              <h2 className="form-heading">
                {id ? "Edit Employee" : "Add Employee"}
              </h2>
            </div>
            <div className="form-section">
              <h2 className="form-title">Personal Details</h2>
              <div className="form-grid">
                <div className="form-group">
                  <label htmlFor="employeeType">Employee Type</label>
                  <Field
                    name="employee_type"
                    component={CustomSelect}
                    options={employeeType}
                  />
                  <ErrorMessage
                    name="employee_type"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="first_name">First Name</label>
                  <Field
                    id="first_name"
                    name="first_name"
                    className="form-control"
                    type="text"
                    placeholder="Enter first name"
                  />
                  <ErrorMessage
                    name="first_name"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="last_name">Last Name</label>
                  <Field
                    id="last_name"
                    name="last_name"
                    className="form-control"
                    type="text"
                    placeholder="Enter last name"
                  />
                  <ErrorMessage
                    name="last_name"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <Field
                    id="email"
                    name="email"
                    className="form-control"
                    type="email"
                    placeholder="Enter email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="mobile_no">Mobile Number</label>
                  <PhoneInput
                    name="mobile_no"
                    country="us"
                    inputStyle={{ width: "100%" }}
                    inputProps={{ name: "mobile", required: true }}
                    value={values.mobile_no || ""}
                    onChange={(phone) => setFieldValue("mobile_no", phone)}
                  />
                  <ErrorMessage
                    name="mobile_no"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="gender">Gender</label>
                  <Field
                    as="select"
                    id="gender"
                    name="gender"
                    className="form-control"
                  >
                    <option value="">Select Gender</option>
                    {genders.map((gender) => (
                      <option key={gender.value} value={gender.value}>
                        {gender.label}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="gender"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="street_1">Street 1</label>
                  <Field
                    id="street_1"
                    name="street_1"
                    className="form-control"
                    placeholder="Enter street 1"
                  />
                  <ErrorMessage
                    name="street_1"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="street_2">Street 2</label>
                  <Field
                    id="street_2"
                    name="street_2"
                    className="form-control"
                    placeholder="Enter street 2"
                  />
                  <ErrorMessage
                    name="street_2"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="country">Country</label>
                  <Field
                    name="country"
                    component={CustomSelect}
                    options={countryList}
                  />
                  <ErrorMessage
                    name="country"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="state">State</label>
                  <Field
                    id="state"
                    name="state"
                    className="form-control"
                    type="text"
                    placeholder="Enter state"
                  />
                  <ErrorMessage
                    name="state"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="city">City</label>
                  <Field
                    id="city"
                    name="city"
                    className="form-control"
                    type="text"
                    placeholder="Enter city"
                  />
                  <ErrorMessage
                    name="city"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="pincode">
                    {values.country === "us" ? "Zipcode" : "Pincode"}
                  </label>
                  <Field
                    id="pincode"
                    name="pincode"
                    className="form-control"
                    type="text"
                    placeholder={
                      values.country === "us" ? "Zipcode" : "Pincode"
                    }
                  />
                  <ErrorMessage
                    name="pincode"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>
              <h2 className="form-title">Bank Details</h2>
              <div className="modern-grid">
                <FieldArray name="bank_details">
                  {({ insert, remove, push }) => (
                    <>
                      {values.bank_details?.length > 0 &&
                        values.bank_details?.map((bankDetail, index) => (
                          <div
                            key={index}
                            className="rounded-lg p-5 mb-6 shadow-md"
                          >
                            <div className="bank-account-card">
                              <div className="account-top">
                                <div className="account-title">
                                  Account #{index + 1}
                                </div>
                                <div className="account-btns">
                                  <button
                                    type="button"
                                    className="icon-btn add"
                                    onClick={() =>
                                      push({
                                        account_holder_name: "",
                                        bank_name: "",
                                        account_type: "",
                                        bank_account_no: "",
                                        bank_account_no_cnf: "",
                                        routing_number: "",
                                        is_primary: false,
                                        ifsc_code: "",
                                      })
                                    }
                                  >
                                    <AiOutlinePlus size={18} />
                                    <span>Add</span>
                                  </button>

                                  {index > 0 && (
                                    <button
                                      type="button"
                                      className="icon-btn remove"
                                      onClick={() => remove(index)}
                                    >
                                      <AiOutlineDelete size={18} />
                                      <span>Remove</span>
                                    </button>
                                  )}
                                </div>
                              </div>

                              <div className="primary-toggle">
                                <Field
                                  type="checkbox"
                                  id={`bank_details.${index}.is_primary`}
                                  name={`bank_details.${index}.is_primary`}
                                  onClick={() => {
                                    const updatedDocs =
                                      values.bank_details?.map((item, idx) => ({
                                        ...item,
                                        is_primary: idx === index,
                                      }));
                                    setFieldValue("bank_details", updatedDocs);
                                  }}
                                />
                                <label
                                  htmlFor={`bank_details.${index}.is_primary`}
                                >
                                  Primary Account
                                </label>
                              </div>
                            </div>

                            {/* All Fields in One Row */}
                            <div className="form-grid">
                              <div className="form-group">
                                <label>
                                  Account Holder Name
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id={`bank_details.${index}.account_holder_name`}
                                  name={`bank_details.${index}.account_holder_name`}
                                  type="text"
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                <ErrorMessage
                                  name={`bank_details.${index}.account_holder_name`}
                                  component="div"
                                  className="text-red-500 text-sm mt-1"
                                />
                              </div>

                              <div className="form-group">
                                <label>
                                  Bank Name{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id={`bank_details.${index}.bank_name`}
                                  name={`bank_details.${index}.bank_name`}
                                  type="text"
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                <ErrorMessage
                                  name={`bank_details.${index}.bank_name`}
                                  component="div"
                                  className="text-red-500 text-sm mt-1"
                                />
                              </div>

                              <div className="form-group">
                                <label>
                                  Bank Branch{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id={`bank_details.${index}.bank_branch`}
                                  name={`bank_details.${index}.bank_branch`}
                                  type="text"
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                <ErrorMessage
                                  name={`bank_details.${index}.bank_branch`}
                                  component="div"
                                  className="text-red-500 text-sm mt-1"
                                />
                              </div>

                              {values.country === "us" && (
                                <div className="form-group">
                                  <label>
                                    Account Type{" "}
                                    <span className="text-red-500">*</span> 
                                  </label>
                                  <Field
                                    id={`bank_details.${index}.account_type`}
                                    name={`bank_details.${index}.account_type`}
                                    type="text"
                                    className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                  />
                                  <ErrorMessage
                                    name={`bank_details.${index}.account_type`}
                                    component="div"
                                    className="text-red-500 text-sm mt-1"
                                  />
                                </div>
                              )}

                              <div className="form-group">
                                <label>
                                  Bank Account No{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id={`bank_details.${index}.bank_account_no`}
                                  name={`bank_details.${index}.bank_account_no`}
                                  type="text"
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                />
                                <ErrorMessage
                                  name={`bank_details.${index}.bank_account_no`}
                                  component="div"
                                  className="text-red-500 text-sm mt-1"
                                />
                              </div>

                              <div className="form-group">
                                <label>
                                  Confirm Account No{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  id={`bank_details.${index}.bank_account_no_cnf`}
                                  name={`bank_details.${index}.bank_account_no_cnf`}
                                  type="text"
                                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                  onCut={handleCut}
                                  onCopy={handleCopy}
                                  onPaste={handlePaste}
                                />
                                <ErrorMessage
                                  name={`bank_details.${index}.bank_account_no_cnf`}
                                  component="div"
                                  className="text-red-500 text-sm mt-1"
                                />
                              </div>

                              {values.country === "us" && (
                                <div className="form-group">
                                  <label>
                                    Routing Number{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    id={`bank_details.${index}.routing_number`}
                                    name={`bank_details.${index}.routing_number`}
                                    type="text"
                                    className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                  />
                                  <ErrorMessage
                                    name={`bank_details.${index}.routing_number`}
                                    component="div"
                                    className="text-red-500 text-sm mt-1"
                                  />
                                </div>
                              )}

                              {values.country === "in" && (
                                <div className="form-group">
                                  <label>
                                    IFSC Code{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    id={`bank_details.${index}.ifsc_code`}
                                    name={`bank_details.${index}.ifsc_code`}
                                    type="text"
                                    className="w-full border border-gray-300 rounded-md px-3 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                  />
                                  <ErrorMessage
                                    name={`bank_details.${index}.ifsc_code`}
                                    component="div"
                                    className="text-red-500 text-sm mt-1"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                    </>
                  )}
                </FieldArray>
              </div>
              <h2 className="form-title">Company Details</h2>
              <div className="form-grid">
                <div className="form-group modern">
                  <div className="form-label">
                    <label>
                      Select Branch <span className="required">*</span>{" "}
                      <CiSquarePlus
                        className="add-icon"
                        onClick={() => setBranchModal(true)}
                        title="Add Branch"
                      />
                    </label>
                  </div>
                  <Field
                    name="branch_id"
                    component={CustomSelect}
                    options={branchData?.map((item) => ({
                      label: item.branch_name,
                      value: item.id,
                    }))}
                  />
                  <ErrorMessage
                    name="branch_id"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group modern">
                  <div className="form-label">
                    <label>
                      Select Department <span className="required">*</span>{" "}
                      <CiSquarePlus
                        className="add-icon"
                        onClick={() => setDepartmentModal(true)}
                        title="Add Department"
                      />
                    </label>
                  </div>
                  <Field
                    name="department_id"
                    component={CustomSelect}
                    options={departmentData}
                  />
                  <ErrorMessage
                    name="department_id"
                    component="div"
                    className="error-message"
                  />
                </div>

                <div className="form-group modern">
                  <div className="form-label">
                    <label>
                      Select Designation <span className="required">*</span>{" "}
                      <CiSquarePlus
                        className="add-icon"
                        onClick={() => setDesignationModal(true)}
                        title="Add Designation"
                      />
                    </label>
                  </div>
                  <Field
                    name="designation_id"
                    component={CustomSelect}
                    options={designationData}
                  />
                  <ErrorMessage
                    name="designation_id"
                    component="div"
                    className="error-message"
                  />
                </div>
              </div>
              <h2 className="form-title">Employee Documents</h2>
              <div className="usa-accordion__content document-section">
                <FieldArray name="document_info">
                  {({ insert, remove, push }) => (
                    <>
                      <table className="document-table">
                        <thead>
                          <tr>
                            <th>
                              <IoDocumentAttach /> Document Name{" "}
                              <span className="required">*</span>
                            </th>
                            <th>
                              <FaCloudUploadAlt /> Upload{" "}
                              <span className="required">*</span>
                            </th>
                            <th>
                              <HiMiniDocumentMagnifyingGlass /> Preview
                            </th>
                            <th>
                              <GrAction /> Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {values.document_info?.map((doc, index) => (
                            <tr key={index}>
                              {/* Document Name */}
                              <td>
                                <Field
                                  className="modern-input"
                                  name={`document_info.${index}.document_name`}
                                  type="text"
                                  placeholder="e.g., ID Proof"
                                />
                                {errors.document_info?.[index]?.document_name &&
                                  touched.document_info?.[index]
                                    ?.document_name && (
                                    <div className="error-message">
                                      {
                                        errors.document_info[index]
                                          .document_name
                                      }
                                    </div>
                                  )}
                              </td>

                              {/* File Upload */}
                              <td>
                                <Field
                                  name={`document_info.${index}.employee_documents`}
                                >
                                  {() => (
                                    <input
                                      type="file"
                                      className="modern-file"
                                      onChange={(event) =>
                                        handleFileChange(
                                          event,
                                          index,
                                          setFieldValue
                                        )
                                      }
                                    />
                                  )}
                                </Field>
                                {errors.document_info?.[index]
                                  ?.employee_documents &&
                                  touched.document_info?.[index]
                                    ?.employee_documents && (
                                    <div className="error-message">
                                      {
                                        errors.document_info[index]
                                          .employee_documents
                                      }
                                    </div>
                                  )}
                              </td>

                              {/* View Button */}
                              <td className="centered">
                                <button
                                  type="button"
                                  className="icon-button view"
                                  disabled={
                                    !values.document_info[index]
                                      .employee_documents
                                  }
                                  onClick={() => {
                                    const base64 =
                                      values.document_info[index]
                                        .employee_documents;
                                    if (base64) {
                                      const newWindow = window.open();
                                      newWindow.document.write(
                                        `<img src="${base64}" alt="Uploaded Document" />`
                                      );
                                    }
                                  }}
                                >
                                  👁
                                </button>
                              </td>

                              {/* Action */}
                              <td className="centered">
                                {index > 4 && (
                                  <button
                                    type="button"
                                    className="icon-button delete"
                                    onClick={() => remove(index)}
                                  >
                                    <RiDeleteBinFill />
                                  </button>
                                )}
                                {index === values.document_info.length - 1 && (
                                  <button
                                    type="button"
                                    className="icon-button add"
                                    onClick={() =>
                                      push({
                                        document_name: "",
                                        employee_documents: "",
                                      })
                                    }
                                  >
                                    <MdAddToPhotos />
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </>
                  )}
                </FieldArray>
              </div>
            </div>

            <div className="form-footer">
              <button type="submit" className="btn btn-submit">
                {id ? "Update" : "Submit"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
      {departmentModal && (
        <CommonModal
          open={departmentModal}
          onClose={handleClose}
          title={"Add Department"}
          size="large"
        >
          <DepartmentForm onClose={handleClose} />
        </CommonModal>
      )}
      {branchModal && (
        <CommonModal
          open={branchModal}
          onClose={handleClose}
          title={"Add Branch"}
          size="large"
        >
          <BranchForm onClose={handleClose} />
        </CommonModal>
      )}
      {designationModal && (
        <CommonModal
          open={designationModal}
          onClose={handleClose}
          title={"Add Designation"}
          size="large"
        >
          <DesignationForm onClose={handleClose} />
        </CommonModal>
      )}
      {permissionMassage == true && (
        <PermissionMessage
          open={true}
          handleClose={() => {
            setPermissionMassage(false);
          }}
        />
      )}
    </div>
  );
}
